// extracted by mini-css-extract-plugin
export default {"countryFlag":"country-flag_countryFlag__m4osM"};